// components/common/CustomTable.jsx
import React from 'react';
import { Table } from 'antd';

const CustomTable = ({
  columns,
  dataSource,
  loading = false,
  rowKey = '_id',
  pagination = true,
  size = 'small',
  scroll = { x: 'max-content' },
  className = '',
  onRow,
  ...props
}) => {
  const defaultPagination = {
    showSizeChanger: true,
    showQuickJumper: window.innerWidth >= 768,
    showTotal: (total, range) => (
      <span className="text-xs sm:text-sm">
        {window.innerWidth >= 640 
          ? `${range[0]}-${range[1]} of ${total} items`
          : `${total} total`
        }
      </span>
    ),
    pageSize: 20,
    size: 'small',
    simple: window.innerWidth < 480,
    position: ['bottomCenter'],
    showLessItems: window.innerWidth < 768
  };

  const paginationConfig = pagination === false 
    ? false 
    : { ...defaultPagination, ...(typeof pagination === 'object' ? pagination : {}) };

  return (
    <div className="h-full flex flex-col">
      <Table
        columns={columns}
        dataSource={dataSource}
        rowKey={rowKey}
        loading={loading}
        scroll={scroll}
        pagination={paginationConfig}
        size={size}
        className={`responsive-table ${className}`}
        onRow={onRow}
        {...props}
      />
      
      <style jsx>{`
        .responsive-table {
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        
        .responsive-table .ant-table-container {
          flex: 1;
          overflow: hidden;
        }
        
        .responsive-table .ant-table {
          font-size: 12px;
          height: 100%;
        }
        
        .responsive-table .ant-table-body {
          overflow-y: auto !important;
          max-height: none !important;
        }
        
        @media (min-width: 640px) {
          .responsive-table .ant-table {
            font-size: 14px;
          }
        }
        
        .responsive-table .ant-table-thead > tr > th {
          padding: 8px 4px;
          font-size: 11px;
          font-weight: 600;
          white-space: nowrap;
          position: sticky;
          top: 0;
          z-index: 10;
          background: white;
        }
        
        @media (min-width: 640px) {
          .responsive-table .ant-table-thead > tr > th {
            padding: 12px 8px;
            font-size: 13px;
          }
        }
        
        .responsive-table .ant-table-tbody > tr > td {
          padding: 6px 4px;
          white-space: nowrap;
        }
        
        @media (min-width: 640px) {
          .responsive-table .ant-table-tbody > tr > td {
            padding: 10px 8px;
          }
        }
        
        @media (max-width: 640px) {
          .responsive-table .ant-table-container {
            border-radius: 6px;
          }
          
          .responsive-table .ant-pagination {
            margin: 16px 0 0 0;
            flex-shrink: 0;
          }
          
          .responsive-table .ant-pagination-options {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default CustomTable;